/** ROS 2 `/hardware/set_spot_light` — `controlboard_interfaces/srv/SetSpotLight` */

import { LightState } from "lib/consts/ARC/light";

export const SPOT_LIGHT_SERVICE = "/hardware/set_spot_light";
export const SPOT_LIGHT_SERVICE_TYPE = "controlboard_interfaces/srv/SetSpotLight";
/** Spot light telemetry from `r2c2_controlboard` (`hardware_feedback_v1` → `/hardware/spot_light`). */
export const SPOT_LIGHT_TOPIC = "/hardware/spot_light";

/**
 * @param {boolean} on
 * @param {number} brightnessPercent 0–100
 * @returns {[string, { on: boolean, brightness_percent: number }, { serviceType: string }]}
 */
export const setSpotLight = (on, brightnessPercent = 100) => {
    const b = Math.min(100, Math.max(0, Math.floor(Number(brightnessPercent) || 0)));
    return [
        SPOT_LIGHT_SERVICE,
        { on, brightness_percent: b },
        { serviceType: SPOT_LIGHT_SERVICE_TYPE },
    ];
};

/**
 * Normalize `/hardware/spot_light` payloads (std_msgs/String JSON or nested `data`).
 * @param {unknown} msg
 * @returns {{ on: boolean, brightnessPercent: number } | null}
 */
export const parseSpotLightTopicPayload = (msg) => {
    try {
        let payload = msg;
        if (typeof msg === "string") {
            payload = JSON.parse(msg);
        } else if (msg != null && typeof msg === "object") {
            const record = /** @type {Record<string, unknown>} */ (msg);
            const raw = record.data;
            if (typeof raw === "string") {
                payload = JSON.parse(raw);
            } else if (raw != null && typeof raw === "object") {
                payload = raw;
            } else if ("on" in record || "brightness_percent" in record) {
                payload = record;
            }
        }
        if (payload == null || typeof payload !== "object") {
            return null;
        }
        const spot = /** @type {Record<string, unknown>} */ (payload);
        const onVal = spot.on;
        const on = onVal === true || onVal === 1 || onVal === "1";
        const brightnessPercent = Number(spot.brightness_percent);
        if (!Number.isFinite(brightnessPercent) || brightnessPercent < 0 || brightnessPercent > 100) {
            return null;
        }
        return { on, brightnessPercent };
    } catch {
        return null;
    }
};

/**
 * @param {{ on: boolean, brightnessPercent: number }} payload
 * @returns {import("lib/consts/ARC/light").LightStateValue}
 */
export const spotLightStateFromPayload = ({ on }) => (on ? LightState.ON : LightState.OFF);

/**
 * Read `spot_light` from a SetSpotLight `hardware_command_json` response.
 * @param {unknown} json
 * @returns {{ on: boolean, brightnessPercent: number } | null}
 */
export const parseSpotLightFromHardwareCommandJson = (json) => {
    try {
        const cmd = typeof json === "string" ? JSON.parse(json) : json;
        const spotLight = cmd?.spot_light;
        return parseSpotLightTopicPayload(spotLight);
    } catch {
        return null;
    }
};
